<template>
  <div
    :class="['live-exercise-list-item', { 'non-trophy-exercise': nonTrophyExercise }]"
    :style="`--completion-icon-size: ${correctIcon ? '24px' : '40px'};`"
  >
    <jz-icon :src="exerciseTypeIcon" class="exercise-type-icon" />

    <span class="exercise-title">{{ exercise.title }}</span>

    <span class="tags">
      <span class="exercise-function">{{ skillTitle | __ }}</span>
      <span class="exercise-type">{{ `exercise.type.${exerciseType}` | __ }}</span>
    </span>

    <!-- ToDo: Show trophy -->
    <span class="finished" v-if="exercise.isCompleted">
      <jz-icon :src="this.icons.checked" />
    </span>

    <span class="best-score" v-if="!nonTrophyExercise && exercise.isCompleted">
      {{ "tt-live.best-score" | __ }}: {{ exercise.bestScore }} / {{ exercise.numQuestions }}
    </span>

    <span class="last-time" v-if="exercise.lastTimeToCompletion !== null">
      {{ "tt-live.last-time" | __ }}: {{ "common.minutes" | __(lastTimeToCompletion) }}
    </span>
  </div>
</template>

<script>
import { getExerciseIcon, getSkillTitle } from "@tt-app/utils";
import { NON_TROPHY_EXERCISES } from "@tt-app/constants";

import iconChecked from "@joyz/app-core/assets/icons/Correct.svg";

export default {
  name: "LiveExerciseListItem",

  props: {
    completionIcon: {
      type: String,
      default: ""
    },
    exercise: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      icons: {
        checked: iconChecked
      }
    };
  },

  computed: {
    exerciseType() {
      return this.exercise.exerciseType || this.exercise.type;
    },

    exerciseTypeIcon() {
      const type = this.exerciseType;
      if (type) {
        return getExerciseIcon(type, this.skill);
      }
      return "";
    },

    lastTimeToCompletion() {
      return this.exercise.lastTimeToCompletion;
    },

    nonTrophyExercise() {
      return NON_TROPHY_EXERCISES.includes(this.exerciseType);
    },

    skill() {
      return this.exercise.skill;
    },

    skillTitle() {
      return getSkillTitle(this.exerciseType, this.skill);
    },

    correctIcon() {
      return this.completionIcon.includes("Correct");
    }
  }
};
</script>

<style lang="scss">
.live-exercise-list-item {
  border-top: 1px solid rgba(var(--rgb-black), 0.08);
  column-gap: $gutter;
  display: grid;
  grid-template-areas: "type-icon title finished" "type-icon tags finished" "type-icon best-score finished" "type-icon last-time finished";
  grid-template-columns: 24px 99fr 1fr;
  grid-template-rows: auto auto auto auto;
  padding: $gutter;
  row-gap: ($gutter / 4);

  &:hover {
    cursor: pointer;
  }

  .exercise-type-icon {
    align-self: center;
    grid-area: type-icon;
  }

  .exercise-title {
    color: var(--color-dark);
    font-size: $font-size-sm;
    font-weight: bold;
    grid-area: title;
  }

  .tags {
    grid-area: tags;

    .exercise-function {
      background-color: var(--color-primary-alternate-background-light);
      border-radius: 4px;
      color: var(--color-secondary);
      font-size: $font-size-xxs;
      font-weight: bold;
      margin: 0 ($gutter / 4) 0 0;
      padding: ($gutter / 4);
    }

    .exercise-type {
      color: var(--color-secondary);
      font-size: $font-size-xs;
      font-weight: bold;
    }
  }

  .finished {
    align-items: center;
    display: flex;
    grid-area: finished;

    .completion-icon {
      height: var(--completion-icon-size);
    }
  }

  .best-score {
    color: var(--color-dark);
    font-size: $font-size-sm;
    grid-area: best-score;
  }

  .last-time {
    color: var(--color-dark);
    font-size: $font-size-sm;
    grid-area: last-time;
  }
}

@include responsive(tablet) {
  .live-exercise-list-item {
    grid-template-areas: "type-icon title best-score finished" "type-icon tags last-time finished";
    grid-template-columns: 24px 49fr 49fr 2fr;
    grid-template-rows: auto auto;

    &.non-trophy-exercise {
      grid-template-areas: "type-icon title last-time finished" "type-icon tags last-time finished";
    }
  }

  .best-score {
    text-align: right;
  }

  .last-time {
    align-self: center;
    text-align: right;
  }
}
</style>
